import PolicyPage from "./PolicyPage";

export default function PrivacyPolicy() {
  return <PolicyPage testid="page-privacy" policyKey="privacy" />;
}
